import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import MaskedView from '@react-native-masked-view/masked-view';
import { LinearGradient } from 'expo-linear-gradient';
import { uniq } from 'ramda';
import { memo, ReactNode } from 'react';
import { ScrollView, StyleProp, View, ViewStyle } from 'react-native';
import { TagButton } from './TagButton';

// -webkit-gradient(linear, left top, left 20%, from(rgba(0,0,0,0)), to(rgba(0,0,0,1)))
const Mask = memo(
  (props: { style?: StyleProp<ViewStyle>; children: ReactNode }) => {
    return (
      <MaskedView
        style={props.style}
        maskElement={
          <LinearGradient
            colors={['black', 'transparent']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            locations={[0.8, 1]}
            css={`
              flex: 1;
            `}
          />
        }
      >
        {props.children}
      </MaskedView>
    );
  },
);

export const TagButtonBar = memo(
  ({
    tags,
    style,
    activeTag,
    onTagPress,
    onAddTag,
  }: {
    tags: string[];
    activeTag?: string;
    style?: StyleProp<ViewStyle>;
    onTagPress: (name: string) => void;
    onAddTag?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <LayoutProviderView style={style}>
        <View
          css={`
            flex: 1;
            flex-direction: row;
            align-items: center;
            padding-left: ${rpx(15)}px;
          `}
        >
          <Mask
            css={`
              flex: 1;
              flex-direction: row;
            `}
          >
            <ScrollView
              horizontal
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={{ paddingRight: rpx(24) }}
              css={`
                flex: 1;
              `}
            >
              {uniq(tags).map(tag => (
                <TagButton
                  key={tag}
                  name={tag}
                  active={activeTag === tag}
                  css={`
                    margin-top: ${rpx(15)}px;
                    margin-bottom: ${rpx(15)}px;
                  `}
                  onPress={onTagPress}
                  icon={<Icon name="hashtag" size={rpx(24)} color="orange" />}
                />
              ))}
            </ScrollView>
          </Mask>
          <TagButton
            name="自定义"
            icon={
              <Icon
                name="add-circle-outline"
                size={rpx(26)}
                color={StatusColors.Info}
              />
            }
            onPress={onAddTag}
          />
        </View>
      </LayoutProviderView>
    );
  },
);
